module.exports = __webpack_public_path__ + "img/img_vs@2x.4c775ed2.png";